const statusScript = document.createElement('script');

statusScript.src = 'https://l807fw49vlx0.statuspage.io/embed/script.js';
statusScript.async = true;

document.body.appendChild(statusScript);
